import BButton from 'components/common/BButton';
import BImage from 'components/common/BImage';
import CloseIcon from 'components/Icons/close.svg';
import { FunctionComponent } from 'react';
import { Keyboard, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

interface VehicleDetailGalleryProps {
  images: string[];
  vehicleName: string;
  setShow: (val: boolean) => void;
  initialIndex: number;
}

const VehicleDetailGallery: FunctionComponent<VehicleDetailGalleryProps> = ({
  images,
  setShow,
  vehicleName,
  initialIndex,
}) => {
  return (
    <div className="h-full w-full bg-slate-900 p-4">
      <Swiper
        className="h-full w-full"
        modules={[Pagination, Navigation, Keyboard]}
        pagination={{ type: 'fraction' }}
        navigation
        spaceBetween={0}
        slidesPerView={1}
        initialSlide={initialIndex}
        keyboard={{ enabled: true, onlyInViewport: true, pageUpDown: true }}
      >
        {images.map((image, idx) => (
          <SwiperSlide key={`gallery-image-${idx}`}>
            <BImage
              src={image}
              layout="fill"
              alt={`${vehicleName}-${idx}`}
              objectFit="contain"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <BButton
        priority="text"
        className="absolute top-4 right-6 z-10 !bg-slate-900 text-white hover:!bg-slate-800"
        onClick={() => setShow(false)}
      >
        <CloseIcon className="h-6 w-6" onClick={() => setShow(false)} />
      </BButton>
    </div>
  );
};

export default VehicleDetailGallery;
